import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import SectionLoader from "../SectionLoader"
import ItemsColumns from "../ItemsColumns"
import styles from './InApartmentSection.module.scss'

const cx = classnames.bind(styles);

const InApartmentSection = function ({
  isLoading = false,
  info = {},
  className = ''
}) {
  const listObj = info?.nestedList?.items
  const itemsOrdered = listObj
    ? Object.keys(listObj)
      .map((id) => ({id, ...listObj[id]}))
      .sort((a, b) => b.order > a.order ? -1 : 1)
    : []

  return (
    <div className={cx('root', className)}>
      {isLoading ? <SectionLoader className={cx('root', 'loader-root')} /> : (
        <ItemsColumns items={itemsOrdered} />
      )}
    </div>
  )
}

InApartmentSection.propTypes = {
  data: PropTypes.any,
  info: PropTypes.object,
  isLoading: PropTypes.bool,
  className: PropTypes.string
}

export default InApartmentSection
